import firebase from 'firebase';
import 'firebase/firestore';
import 'firebase/functions';
import { EventTypes } from 'redux-segment';
import moment from 'moment';
import _ from 'lodash';
import LogRocket from 'logrocket';
import { makeDebugger } from 'lib';
import Log from 'lib/Log';

import * as at from "./actionTypes";

const debug = makeDebugger('services/auth/actions');


const handleAuthSuccess = (data, dispatch) => {
  debug('auth success: ', data);
  const user = {
    name: data.displayName,
    email: data.email,
    photoURL: data.photoURL,
    uid: data.uid,
    provider: data.providerData.providerId
  }
  // Logger information for session
  LogRocket.identify(data.uid, {
    name: data.displayName,
    email: data.email
  });
  dispatch({
    type: at.IS_AUTHENTICATED,
    payload: user,
    meta: {
      analytics: {
        eventType: EventTypes.identify,
        eventPayload: {
          userId: user.uid,
          traits: {
            ...user
          }
        }
      }
    }
  });
}

// const handleAuthFail = (dispatch) => {
//   dispatch({ type: at.IS_NOT_AUTHENTICATED })
//   logout(dispatch);
// }

// const inBeta = (email) => {
//   return new Promise((resolve, reject) => {
//     const betaList = firebase.firestore().collection("beta_users");
//     betaList.doc(email).get()
//       .then(doc => doc.exists && doc.data().valid === true)
//       .then(inBeta => {
//         const result = !inBeta && _.includes(email, '@partech')
//           ? true : inBeta;
//         resolve(result);
//       })
//       .catch(err => reject(err))
//   });
// }

const handleNewAccount = (user, dispatch) => {
  debug('handling new account created')
  dispatch({
    type: at.ACCOUNT_CREATED,
    meta: {
      analytics: [{
        eventType: 'track',
        eventPayload: {
          event: 'Account Created'
        }
      }, {
        eventType: 'alias',
        eventPayload: {
          userId: user.uid,
          previousId: user.email
        }
      }]
    }
  })
  // inBeta(user.email)
  //   .then(inBeta => {
  //     debug("user is in beta: ", inBeta);
  //     if (!inBeta) {
  //       debug('failing authentication')
  //       handleAuthFail(dispatch);
  //     } else {
  //       // TODO: should I check if they came from welcome list or not??
  //       handleAuthSuccess(user, dispatch);
  //     }
  //   });
  // const inBetaList = firebase.functions().httpsCallable("isBetaUser");
}

const handleAuthed = (user, dispatch) => {
  debug('handling Auth: ', user);
  if (userJustCreated(user)) {
    handleNewAccount(user, dispatch)
  }
  handleAuthSuccess(user, dispatch)
  // else {
  //   // check if user in Beta
  //   console.log(data.uid)
  //   firebase.firestore().collection('users').doc(data.uid).get()
  //     .then((doc) => {
  //       console.log(doc)
  //       if (doc.data() && doc.data().inBeta) {
  //         handleAuthSuccess(data, dispatch)
  //       } else {
  //         handleAuthFail(dispatch)
  //       }
  //     })
  // }
}

export const getLoggedInUser = () => {
	return (dispatch) => {
		dispatch({ type: at.LOGIN })
		firebase.auth().onAuthStateChanged((user) => {
			user
        ? handleAuthed(user, dispatch)
        : dispatch({ type: at.IS_NOT_AUTHENTICATED })
		});
	};
};

// ADDITIONAL DEVELOPER ERRORS
// auth/auth-domain-config-required
// 	Thrown if authDomain configuration is not provided when calling firebase.initializeApp(). Check Firebase Console for instructions on determining and passing that field.
// auth/operation-not-allowed
//  Thrown if the type of account corresponding to the credential is not enabled. Enable the account type in the Firebase Console, under the Auth tab.
// auth/operation-not-supported-in-this-environment
// 	Thrown if this operation is not supported in the environment your application is running on. "location.protocol" must be http or https.
// auth/unauthorized-domain
// 	Thrown if the app domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.
const getMessageForError = (code) => {
	const codes = {
		"auth/user-disabled": "We don't seem to recognize that account.",
		"auth/user-not-found": "We don't seem to recognize that account.",
		"auth/wrong-password": "Whoops! That password you entered does not seem to be correct.",
		"auth/cancelled-popup-request": "Looks like you've opened multiple windows to login!",
		"auth/popup-blocked": "The login popup has been blocked, please make sure the settings in your browser enable popups for this app.",
		"auth/popup-closed-by-user": "Looks like you cancelled the login request.",
		"auth/invalid-email": "That email doesn't look right, please check that you've entered it correctly",
    "auth/network-request-failed": "Please make sure you're connected to the internet.",
    "auth/weak-password": "Password should be at least 6 characters."
	}
	return codes[code];
}

/* Helper Method */
const loginUserFail = (dispatch, err) => {
  Log.error(err.message, 'services/auth/actions');
  if (err.code === 'auth/account-exists-with-different-credential') {
    handleAccountExists(dispatch, err);
  } else {
    dispatch({ type: at.LOGIN_FAIL, payload: getMessageForError(err.code) });
  }
};

const userJustCreated = (user) => {
  const creationTime = user.metadata.creationTime;
	return moment().subtract(1, 'minute').isBefore(creationTime);
}

/* Helper Method */
const loginUserSuccess = (dispatch, user, from) => {
  if (!userJustCreated(user)) {
    dispatch({ type: at.LOGIN_SUCCESS, payload: user });
  }
};

// Logs in a user via email and password
// First checks to make sure that the user doesn't already have another
// account with Google
export const loginUser = (email, password, from) => {
  return dispatch => {
    debug('logging in user')
    dispatch({ type: at.LOGIN });

		firebase.auth().fetchSignInMethodsForEmail(email)
			.then((providers) => {
				debug('primary provider:', providers[0])
				if (providers[0] === 'google.com') {
					dispatch({ type: at.LOGIN_FAIL, payload:
						(`You've already used this email to login via Google,
						please try again using the Google sign in`)
					});
				} else {
					firebase.auth().signInWithEmailAndPassword(email, password)
						.then(user => loginUserSuccess(dispatch, user, from))
						.catch((error) => {
							Log.error(error.message, 'services/auth/actions');
							// loginUserFail(dispatch, error)
							// Create a new user
							if (error.code !== "auth/wrong-password") {
								firebase.auth().createUserWithEmailAndPassword(email, password)
									.then(user => {
										loginUserSuccess(dispatch, user)
									})
									.catch((err) => loginUserFail(dispatch, err));
							} else {
								loginUserFail(dispatch, error)
							}
						});
				}
			}).catch(err => { loginUserFail(dispatch, err) });
	}
};

export const googleLoginUser = () => {
  return dispatch => {
    debug('starting google login')
		dispatch({ type: at.LOGIN });
    var provider = new firebase.auth.GoogleAuthProvider();
    provider.setCustomParameters({
       prompt: 'select_account'
    });
    firebase.auth().signInWithPopup(provider).then(function(result) {
      // This gives you a Google Access Token. You can use it to access the Google API.
      // const token = result.credential.accessToken;
      // The signed-in user info.
      const user = result.user;
      debug('user: ', user);
      loginUserSuccess(dispatch, user);
      // ...
    }).catch(function(error) {
      // Handle Errors here.
      loginUserFail(dispatch, error);
    });
  }
}

export const facebookLoginUser = () => {
	return dispatch => {
		dispatch({ type: at.LOGIN });
		var provider = new firebase.auth.FacebookAuthProvider();
		firebase.auth().signInWithPopup(provider).then(function(result) {
			// This gives you a Facebook Access Token. You can use it to access the Facebook API.
			// const token = result.credential.accessToken;
			// The signed-in user info.
			const user = result.user;
			loginUserSuccess(dispatch, user);
		}).catch(function(error) {
			// Handle Errors here.
			loginUserFail(dispatch, error);
		});
	}
}

const logout = (dispatch) => {
	dispatch({ type: at.LOGOUT });
  window.analytics && window.analytics.reset();
	// TODO: Is there an error to catch here
	firebase.auth().signOut()
  	.then(() => {
  		dispatch({ type: at.LOGOUT_SUCCESS });
  	});
}

export const logoutUser = () => {
	return (dispatch) => {
		logout(dispatch);
	}
}

const getProviderName = (provider) => {
	switch(provider) {
		case 'google.com':
			return 'Google';
		case 'facebook.com':
			return 'Facebook';
		case 'password':
			return 'Email and Password';
		default:
			return provider
	}
}

// Helper method for when...
// (error.code === 'auth/account-exists-with-different-credential') {
const handleAccountExists = (dispatch, error) => {
  // Step 2.
  // User's email already exists.
  // The pending Google credential.
  var pendingCred = error.credential;
  // The provider account's email address.
  var email = error.email;
  // Get registered providers for this email.
  firebase.auth().fetchSignInMethodsForEmail(email)
		.then((providers) => {
	    const provider = getProviderName(providers[0]);
	    dispatch({ type: at.LOGIN_FAIL, payload:
	      (`You've already used this email to login via ${provider},
	        please try again using ${provider}`)})
		}).catch(err => { loginUserFail(dispatch, err) });

		// DOWN THE ROAD, CREATE UI FOR LINKING ACCOUNTS
    // TODO
    // Step 3.
    // If the user has several providers,
    // the first provider in the list will be the "recommended" provider to use.
    // if (providers[0] === 'password') {
    //   // Asks the user his password.
    //   // In real scenario, you should handle this asynchronously.
    //   var password = promptUserForPassword(); // TODO: implement promptUserForPassword.
    //   auth.signInWithEmailAndPassword(email, password).then(function(user) {
    //     // Step 4a.
    //     return user.link(pendingCred);
    //   }).then(function(data) {
    //     // Google account successfully linked to the existing Firebase user.
    //     goToApp();
    //   });
    //   return;
    // }
    // // All the other cases are external providers.
    // // Construct provider object for that provider.
    // // TODO: implement getProviderForProviderId.
    // var provider = getProviderForProviderId(providers[0]);
    // // At this point, you should let the user know that he already has an account
    // // but with a different provider, and let him validate the fact he wants to
    // // sign in with this provider.
    // // Sign in to provider. Note: browsers usually block popup triggered asynchronously,
    // // so in real scenario you should ask the user to click on a "continue" button
    // // that will trigger the signInWithPopup.
    // auth.signInWithPopup(provider).then(function(result) {
    //   // Remember that the user may have signed in with an account that has a different email
    //   // address than the first one. This can happen as Firebase doesn't control the provider's
    //   // sign in flow and the user is free to login using whichever account he owns.
    //   // Step 4b.
    //   // Link to Google credential.
    //   // As we have access to the pending credential, we can directly call the link method.
    //   result.user.link(pendingCred).then(function() {
    //     // Google account successfully linked to the existing Firebase user.
    //     goToApp();
    //   });
    // });
		// });
}



// WEBPACK FOOTER //
// ./src/services/auth/actions.js